var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPastShows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C14.4477 0 14 0.44772 14 1V2H6V1C6 0.44772 5.5523 0 5 0C4.4477 0 4 0.44772 4 1V2H3C1.3431 2 0 3.34315 0 5V12C0 12.5523 0.4477 13 1 13C1.5523 13 2 12.5523 2 12V8H18V17C18 17.5523 17.5523 18 17 18H12C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20H17C18.6569 20 20 18.6569 20 17V5C20 3.34315 18.6569 2 17 2H16V1C16 0.44772 15.5523 0 15 0ZM17 4C17.5523 4 18 4.44772 18 5V6H2V5C2 4.44772 2.4477 4 3 4H17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7071 15.7071C4.0976 15.3166 4.0976 14.6834 3.7071 14.2929C3.3166 13.9024 2.6834 13.9024 2.2929 14.2929L0.292902 16.2929C-0.097598 16.6834 -0.097598 17.3166 0.292902 17.7071L2.2929 19.7071C2.6834 20.0976 3.3166 20.0976 3.7071 19.7071C4.0976 19.3166 4.0976 18.6834 3.7071 18.2929L2.4142 17L3.7071 15.7071Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7071 14.2929C9.0976 14.6834 9.0976 15.3166 8.7071 15.7071L7.4142 17L8.7071 18.2929C9.0976 18.6834 9.0976 19.3166 8.7071 19.7071C8.3166 20.0976 7.6834 20.0976 7.2929 19.7071L5.2929 17.7071C4.9024 17.3166 4.9024 16.6834 5.2929 16.2929L7.2929 14.2929C7.6834 13.9024 8.3166 13.9024 8.7071 14.2929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastShows);
export default __webpack_public_path__ + "static/media/past-shows.8c6fd7cd.svg";
export { ForwardRef as ReactComponent };